export const initPhoneAssignmentConfig = function() {
	const params = window.modUtils.getUrlParamsToObject();
	const ctParam = params.CT && params.CT.toLowerCase();
	if (ctParam === 'yes') {
		window.modForm.opts.phoneAssignmentConfig.showPhoneAssignmentNumber = true;
	}
	window.modForm.opts.phoneAssignmentConfig.useHsEndpoint = true;
};